// All build-time environment variables are read here, so the build tool's
// variable prefix is defined in exactly one place.
const env = {
  PROJECT_CONNECT_API: process.env.REACT_APP_PROJECT_CONNECT_API,
  AUTH_DOMAIN: process.env.REACT_APP_AUTH_DOMAIN,
  AUTH_CLIENT_ID: process.env.REACT_APP_AUTH_CLIENT_ID,
  AUTH_AUDIENCE: process.env.REACT_APP_AUTH_AUDIENCE,
};

const constants = {
  MINIMUM_SCREEN_SIZE_RESPONSIVE: 768,
  MINIMUM_SCREEN_SIZE_POPOVER: 768,
  MINIMUM_SCREEN_XL_POPOVER: 860,
  PROJECT_CONNECT_API_BASE_URL: env.PROJECT_CONNECT_API || '',
  AUTH_DOMAIN: env.AUTH_DOMAIN || '',
  AUTH_CLIENT_ID: env.AUTH_CLIENT_ID || '',
  LOCAL_STORAGE_APPLICATION_ID: 'idexx-pc-application',
  AUTH_AUDIENCE: env.AUTH_AUDIENCE || '',
  SESSION_STORAGE: {
    LOGGED_IN_USER: 'loggedInUser',
    PRACTICE_USERS: 'practiceUsers',
  },
  UNKNOWN_APPLICATION: 'UNKNOWN',
  APPLICATIONS: ['communicator', 'enterprise'],
  SUPPORT_PHONE_HREF: 'tel:+18554255207',
  SUPPORT_PHONE_TEXT: '855-425-5207',
  LOCAL_STORAGE_LOCKOUT_KEY: 'practiceLockoutTime',
  ENTERPRISE_REDIRECT_URL: '',
};

export default constants;
